<template>
  <div class="config-expanded-model-container">
    <div class="header-image">
      <span class="header-image-title">Selecione a imagem do destaque </span>
      <mf-image-cropper
        :mb-size-limit="1"
        :disabled="false"
        :upload-image="modifyImg"
        :error-message="errorMessage"
        :url="imageURL"
        :width="720"
        :height="500"
        show-hint
        @remove-image="deleteFile"
        @snackbar="showSnackbar"
      />
    </div>
    <selected-products />
  </div>
</template>
<script>
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { highlightOffer } from '../../../../mixins/highlight-offer'

export default {
  name: 'ConfigExpandedModel',
  components: {
    SelectedProducts: () => import('./SelectedProducts.vue'),
  },
  mixins: [highlightOffer],
  props: {
    bannerImageError: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ imageUploaded: false }),
  computed: {
    imageURL: {
      get() {
        return this.highlightBannerImage
      },
      set(value) {
        this.setHighlightKeyValue({ payload: value, key: 'bannerImage' })
      },
    },
    errorMessage() {
      return this.bannerImageError ? 'Selecione uma imagem para o destaque.' : ''
    },
  },
  methods: {
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    deleteFile() {
      this.imageURL = ''
    },
    async modifyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.imageUploaded = true
          this.imageURL = url
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.config-expanded-model-container {
  max-width: 100% !important;
  width: 100% !important;
  display: flex;
  flex-direction: column;
  gap: 40px;
  .header-image {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .error-message {
      color: $vermelho-0;
    }
    .header-image-title {
      color: $cinza-d10;
      font-family: Lato;
      font-size: 18px;
      font-weight: 700;
    }
  }
}

::v-deep .mf-image-cropper {
  max-width: 100% !important;
}
</style>
